import { render, staticRenderFns } from "./AllCustomers.vue?vue&type=template&id=7b90620c&scoped=true&"
import script from "./AllCustomers.vue?vue&type=script&lang=js&"
export * from "./AllCustomers.vue?vue&type=script&lang=js&"
import style0 from "./AllCustomers.vue?vue&type=style&index=0&id=7b90620c&prod&lang=scss&"
import style1 from "./AllCustomers.vue?vue&type=style&index=1&id=7b90620c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b90620c",
  null
  
)

export default component.exports